/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerUpdateMutationRequest, FilesControllerUpdateMutationResponse, FilesControllerUpdatePathParams, FilesControllerUpdate400, FilesControllerUpdate401, FilesControllerUpdate403, FilesControllerUpdate404 } from "../../models/filesController/FilesControllerUpdate";

function getFilesControllerUpdateUrl(id: FilesControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/files/${id}` as const }  
  return res
}

/**
 * @summary Update a file
 * {@link /api/v1/files/:id}
 */
export async function filesControllerUpdate(id: FilesControllerUpdatePathParams["id"], data?: FilesControllerUpdateMutationRequest, config: Partial<RequestConfig<FilesControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<FilesControllerUpdateMutationResponse, ResponseErrorConfig<FilesControllerUpdate400 | FilesControllerUpdate401 | FilesControllerUpdate403 | FilesControllerUpdate404>, FilesControllerUpdateMutationRequest>({ method : "PATCH", url : getFilesControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}